import styled from 'styled-components';

export const Container = styled.div`
  margin: 16px 0;
`;

export const Header = styled.div`
  background-color: #F2F2F2;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  border-radius: 4px;

  p{
    color: #282828;
    font-size: 12px;
    font-weight: 600;
    line-height: normal;
    margin: 0;
  }
`;

export const List = styled.div`
  min-height: 120px;
  padding: 0 16px;

  max-height: 200px;
  overflow-y: scroll;
`;

export const Item = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: 8px;

  div{
    display: flex;
    align-items: center;
    gap: 8px;

    input {
      cursor: pointer;
    }
  }

  p{
    color:  #282828;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin: 0px;
  }

  button{
    border: none;
    background-color: transparent;
    height: 18px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  svg{
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const DeleteContainer = styled.div`
  border-radius: 5px;

  .header{
    padding: 8px  12px;
    color: #000;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    border-bottom: 1px solid #282828;
    display: flex;
    justify-content: space-between;

    button{
      background-color: transparent;
      border: none;
      cursor: pointer;
      height: 22px;
    }
  }

  p{
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    padding: 16px;
    margin-bottom: 8px;

    strong{
      font-weight: 700;
    }
  }

  .btn_container{
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-bottom: 16px;

    button{
      background-color: #fff;
      border: 1px solid var(--color-primary);
      border-radius: 4px;
      color: var(--color-primary);
      padding: 8px 16px;
      cursor: pointer;

      &:last-child{
        background-color: var(--color-primary);
        color: #fff;
      }
    }
  }
`;
